import { render } from "./product-selection-bar.vue?vue&type=template&id=370f4900&scoped=true"
import script from "./product-selection-bar.vue?vue&type=script&lang=js"
export * from "./product-selection-bar.vue?vue&type=script&lang=js"

import "./product-selection-bar.vue?vue&type=style&index=0&id=370f4900&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f4900"]])

export default __exports__